import api from "./api";

// Catálogo global de transportadoras (seleção em escala) — PO1-2620, H2.
// Endpoints no backend_hub (módulo transportadoras).
// PO1-3856/PO1-3857: filtros de categoria, sistema, modalidade, "fora da
// carteira" e rota (UF origem/destino). `fonte` saiu da tela.

export async function listCatalogoTransportadoras({
  embarcadorId,
  search,
  regiao,
  capacidade,
  categoria,
  sistema,
  modalidade,
  foraCarteira,
  ufOrigem,
  ufDestino,
  page,
  pageSize,
} = {}) {
  const { data } = await api.get("/transportadoras/catalogo", {
    params: {
      embarcadorId,
      search: search || undefined,
      regiao: regiao || undefined,
      capacidade: capacidade || undefined,
      categoria: categoria || undefined,
      sistema: sistema || undefined,
      modalidade: modalidade || undefined,
      foraCarteira: foraCarteira || undefined,
      ufOrigem: ufOrigem || undefined,
      ufDestino: ufDestino || undefined,
      page,
      pageSize,
    },
  });
  return data;
}

export async function vincularTransportadoras(embarcadorId, ids) {
  const { data } = await api.post("/transportadoras/catalogo/vincular", { embarcadorId, ids });
  return data;
}

export async function baixarModeloPlanilhaTransportadoras() {
  const { data } = await api.get("/transportadoras/catalogo/modelo", { responseType: "blob" });
  return data;
}

export async function importarPlanilhaTransportadoras(embarcadorId, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("embarcadorId", embarcadorId);
  const { data } = await api.post("/transportadoras/catalogo/importar", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
